import React from "react";
import { Appointments } from "@devexpress/dx-react-scheduler-material-ui";

import { green, tintRed } from "globals/design-system/colors";
import { DriverScheduleSettingScheduleTypeEnum } from "types";

const { Available } = DriverScheduleSettingScheduleTypeEnum;

// Custom appointment component for Scheduler
const Appointment = ({ children, style, data, onClick, ...restProps }: any) => {
  const handleClick = () => {
    if (onClick && data.originalEvent) {
      onClick(data.originalEvent);
    }
  };

  return (
    <Appointments.Appointment
      {...restProps}
      style={{
        ...style,
        backgroundColor: data.type === Available ? green : tintRed,
        borderRadius: "4px",
        marginLeft: 0,
        marginRight: 0,
        left: "1px",
        width: "calc(100% - 2px)",
        cursor: "pointer",
      }}
      data={data}
      onClick={handleClick}
    >
      {children}
    </Appointments.Appointment>
  );
};

export default Appointment;
